module.exports = __webpack_public_path__ + "media/images/icons/arrow-back-da3b516d90d8e1df2a3465340fdbdc3b.svg";